import { Injectable, Injector } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { TenantConfigService } from './tenant-config.service';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private hubConnection!: signalR.HubConnection;
  private languageService!: LanguageService;

  constructor(
    private notificationService: NotificationService,
    private tenantConfigService: TenantConfigService,
    private injector: Injector
  ) {}

  public startConnection(userId: string) {
    if (!this.languageService) {
      this.languageService = this.injector.get(LanguageService);
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.tenantConfigService.tenant.notificationServiceBaseUrl}/notificationHub`)
      .build();

    this.hubConnection
      .start()
      .then(() => {
        console.log('SignalR connection started');
        this.addListeners(userId);
      })
      .catch(err => console.log('Error while starting SignalR connection: ' + err));
  }

  private addListeners(userId: string) {
    this.hubConnection.on('ReceiveNotification', (messageStr) => {
      let message = JSON.parse(messageStr);
      
      // Display notification based on current language
      const description = this.languageService.currentLanguage === 'ar' 
        ? message.DescriptionAr 
        : message.DescriptionEn;
      
      this.notificationService.info(description);
      console.log('Message received from server:', message);
    });
    this.hubConnection?.invoke('JoinGroup', userId)
    .catch((err:any) => {
      console.error(`Error while joining group: ${err}`);
    });
  }
 
  public stopConnection() {
    this.hubConnection
      .stop()
      .then(() => console.log('SignalR connection stopped'))
      .catch(err => console.log('Error while stopping SignalR connection: ' + err));
  }
}
